import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'
import Remote from './Large/Remote'
import MobileContainer from './Mobile/MobileContainer'
import Dashboard from './Large/Dashboard'
import MicrophoneAndSwitch from './Large/MicrophoneAndSwitch'
import OldDashboard from './Common/OldDashboard'

interface MenuDisplayerProps {
  hideMenu?: boolean
}

const MenuDisplayer = ({ hideMenu }: MenuDisplayerProps): JSX.Element => {
  const dispatch = useDispatch()
  const menu = useSelector((state: RootState) => state.retorikReducer.configuration.menu)
  const isMobile = useSelector((state: RootState) => state.viewReducer.isMobile)
  const isBorne = useSelector((state: RootState) => state.viewReducer.isBorne)
  const displayControls = useSelector((state: RootState) => state.viewReducer.displayControls)
  const dashboardOpened = useSelector((state: RootState) => state.utilsReducer.dashboardOpened)
  const [topOfRemote, setTopOfRemote] = useState<number | string>()

  return isMobile ? (
    <MobileContainer hideMenu={!!hideMenu} />
  ) : displayControls ? (
    <React.Fragment>
      {isBorne && <MicrophoneAndSwitch top={topOfRemote} />}
      <Remote hideMenu={!!hideMenu} setTopOfRemote={setTopOfRemote} />
      {dashboardOpened &&
        (menu?.categories?.length ? (
          <Dashboard toggleDashboard={() => dispatch(storeActions.utils.toggleDashboard(true))} />
        ) : (
          <OldDashboard toggleDashboard={() => dispatch(storeActions.utils.toggleDashboard(true))} />
        ))}
    </React.Fragment>
  ) : (
    <React.Fragment />
  )
}

export default MenuDisplayer
